













































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {Getter, Action} from 'vuex-class';
import DlgAdNew from '../../../modules/ads/_components/DlgAdNew.vue';
import DlgAdDelete from '../../../modules/ads/_components/DlgAdDelete.vue';
import DlgAdEdit from '../../../modules/ads/_components/DlgAdEdit.vue';
import Card from '../../../components/material/Card.vue';
import ImageUploader from '@/modules/files/_components/imageUploader.vue';

@Component({
  components: {
    ImageUploader,
    DlgAdNew,
    DlgAdDelete,
    DlgAdEdit,
    Card,
  },
})
export default class AdsList extends Vue {
  public $refs!: {
    image: any,
  };

  @Action('articles/upload') private upload!: any;
  @Action('articles/create') private create!: any;
  @Action('articles/setNewArticle') private setNewArticle!: any;

  @Getter('articles/newArticle') private storeNewArticle!: any;

  private loading: boolean = false;
  private menu: boolean = false;
  private dateFormatted: string = '';

  get newArticle() {
    return this.storeNewArticle;
  }

  set newArticle(article) {
    this.setNewArticle(article);
  }

  private created() {
    this.loading = true;
    this.loading = false;
  }

  private async createArticle() {
    this.loading = true;
    const url = await this.$refs.image.doUpload();
    const res = await this.create({...this.newArticle, image: url});
    if (res) {
      this.setNewArticle({});
      this.$router.back();
    }
    this.loading = false;
  }
}
